"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var header_bar_service_1 = require("./api/header-bar.service");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var toggle_full_screen_service_1 = require("../shell-container/api/toggle-full-screen.service");
var material_1 = require("@angular/material");
var about_component_1 = require("./about/about.component");
var navigation_bar_state_1 = require("./model/navigation-bar-state");
var HeaderBarComponent = /** @class */ (function () {
    function HeaderBarComponent(configPath, imagesPath, authenticationService, authorizationService, headerBarService, languageService, messageService, toggleFullScreenService, router, sessionDataProvider, dialog, eventBase) {
        this.configPath = configPath;
        this.imagesPath = imagesPath;
        this.authenticationService = authenticationService;
        this.authorizationService = authorizationService;
        this.headerBarService = headerBarService;
        this.languageService = languageService;
        this.messageService = messageService;
        this.toggleFullScreenService = toggleFullScreenService;
        this.router = router;
        this.sessionDataProvider = sessionDataProvider;
        this.dialog = dialog;
        this.eventBase = eventBase;
        this.showNotificationBell = true;
        this.showUserProfile = true;
        this.showAbout = false;
        this.showContact = false;
        this.showCalendar = false;
        this.showCalendarText = false;
        this.showQRScanner = false;
        this.isFullScreen = true;
        this.createNewPermissionKeys = [];
        this.helpItems = [];
        this._categoryPermissions = new Map();
        this._pinState = navigation_bar_state_1.NavigationBarState.PINNED;
        this._innerWidth = window.innerWidth;
        this._openSubscriptions = [];
        this.USER_CHANGE_EVENT = 'user-change';
        this.CALENDAR_STATE_CHANGE_EVENT = 'calendar-state-changed';
        this.NAVIGATION_BAR_PIN_STATE_CHANGE_EVENT = 'navigation-bar-pin-state-changed';
        this._configSrc = configPath + '/header-config.json';
        this._categoryPermissions.set(idm_authorization_client_js_1.PermissionType.ADD, new Set());
    }
    HeaderBarComponent_1 = HeaderBarComponent;
    HeaderBarComponent.prototype.ngOnChanges = function (changes) {
        if (changes['logoName']) {
            this.logoSrc = Boolean(this.logoName) ? this.imagesPath + "/" + this.logoName : this.imagesPath + "/logo.svg";
        }
    };
    /**
     * Load navigation items and init properties
     */
    HeaderBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._openSubscriptions.push(this.isLoggedOn().subscribe(function (isLoggedIn) {
            if (isLoggedIn) {
                _this.headerBarService.getCreateNewItems(_this._configSrc).then(function (items) {
                    _this.createNewItems = items;
                    _this.createNewPermissionKeys = items.map(function (e) { return e.permissionKey; });
                    _this.loadAddPermissionForCategories(_this.createNewPermissionKeys);
                });
                _this._openSubscriptions.push(_this.getAvailableLanguages().subscribe(function (languages) {
                    _this.availableLanguages = languages;
                    _this.isLanguageButtonVisible = _this.availableLanguages.length > 1;
                }));
                _this._openSubscriptions.push(_this.getCurrentLanguage().subscribe(function (language) {
                    _this.currentLanguageName = language.getAcronym().getValue(language.getId());
                }));
                _this._openSubscriptions.push(_this.isGuestUser().subscribe(function (isGuestUser) {
                    _this._isGuestUser = isGuestUser;
                }));
                _this._openSubscriptions.push(_this.getUserData().subscribe(function (userData) {
                    _this.userData = userData;
                }));
                _this._openSubscriptions.push(_this.eventBase.listen(_this.USER_CHANGE_EVENT).subscribe(function (event) {
                    var user = event.data.user;
                    if (_this.userData.userId === user.id) {
                        _this.userData = {
                            fullName: user.properties.FIRSTNAME + " " + user.properties.LASTNAME,
                            userId: user.id,
                            username: user.login,
                            isSamlUser: _this.userData.isSamlUser
                        };
                    }
                }));
                // setting logo, TODO: For now there is an default logo name if it wasn't provided with binding,
                //  this has done for backward compatibility, but it should be removed in future
                _this.logoSrc = Boolean(_this.logoName) ? _this.imagesPath + "/" + _this.logoName : _this.imagesPath + "/logo.svg";
                _this._isLoggedOn = isLoggedIn;
            }
        }));
        this.listenToNavigationPinState();
        this.listenToCalendarState();
        this.headerBarService.getHelpItems(this._configSrc).then(function (items) {
            _this.helpItems = items;
        });
        this.filterHeaderItems();
        this._openSubscriptions.push(this.toggleFullScreenService.isFullScreen().subscribe(function (value) {
            _this.isFullScreen = value;
        }));
    };
    HeaderBarComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    HeaderBarComponent.prototype.onResize = function (event) {
        this._innerWidth = window.innerWidth;
    };
    HeaderBarComponent.prototype.pinUnpin = function ($event) {
        $event.preventDefault();
        if (this._pinState !== navigation_bar_state_1.NavigationBarState.PINNED) {
            this._pinState = navigation_bar_state_1.NavigationBarState.PINNED;
        }
        else {
            this._pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
        }
        this.eventBase.publish('navigation-bar-pin-state-changed', { pinState: this._pinState });
    };
    HeaderBarComponent.prototype.hover = function () {
        if (this._innerWidth > 720) {
            if (this._pinState === navigation_bar_state_1.NavigationBarState.UNPINNED) {
                this._pinState = navigation_bar_state_1.NavigationBarState.OVERLAID;
            }
            this.eventBase.publish('navigation-bar-pin-state-changed', { pinState: this._pinState });
        }
    };
    HeaderBarComponent.prototype.leave = function () {
        if (this._pinState !== navigation_bar_state_1.NavigationBarState.PINNED) {
            this._pinState = navigation_bar_state_1.NavigationBarState.UNPINNED;
        }
        this.eventBase.publish('navigation-bar-pin-state-changed', { pinState: this._pinState });
    };
    HeaderBarComponent.prototype.openAbout = function () {
        var dialogWidth = '600px';
        var isDefaultAboutComponent = !Boolean(this.aboutComponent);
        if (isDefaultAboutComponent) {
            this.dialog.open(about_component_1.AboutComponent, {
                width: dialogWidth
            });
        }
        else {
            this.dialog.open(this.aboutComponent, {
                width: dialogWidth
            });
        }
    };
    HeaderBarComponent.prototype.openCalendar = function () {
        this._isCalendarOpened = !this._isCalendarOpened;
        this.eventBase.publish('calendar-state-changed', { isCalendarOpened: this._isCalendarOpened });
    };
    HeaderBarComponent.prototype.openQRScanner = function () {
        this.eventBase.publish('qr-scanner-open', null);
    };
    /**
     * Get message by message key
     */
    HeaderBarComponent.prototype.getMessage = function (messageKey) {
        return this.messageService.getMessage(messageKey);
    };
    /**
     * Listen's the event 'change language-switch'
     */
    HeaderBarComponent.prototype.onLanguageChange = function ($event, languageId) {
        $event.preventDefault();
        this.sessionDataProvider.setCurrentLanguageId(languageId);
    };
    /**
     * Logout user and navigate on login page
     */
    HeaderBarComponent.prototype.onLogout = function () {
        this.authenticationService.redirectUrl = '';
        this.sessionDataProvider.logout();
    };
    /**
     * @returns Current user data
     */
    HeaderBarComponent.prototype.getUserData = function () {
        return this.sessionDataProvider.getCurrentUserData();
    };
    /**
     * @returns true if user is logged on otherwise false
     */
    HeaderBarComponent.prototype.isLoggedOn = function () {
        return this.sessionDataProvider.isLoggedOn();
    };
    /**
     * @returns Current Language
     */
    HeaderBarComponent.prototype.getCurrentLanguage = function () {
        return this.sessionDataProvider.getCurrentLanguage();
    };
    /**
     * @returns all available Languages
     */
    HeaderBarComponent.prototype.getAvailableLanguages = function () {
        return this.languageService.getAvailableLanguages();
    };
    /**
     * @returns true when user is guest otherwise  false
     */
    HeaderBarComponent.prototype.isGuestUser = function () {
        return this.authenticationService.isLoggedOnAsGuestUser();
    };
    /**
     * Change current language
     */
    HeaderBarComponent.prototype.changeLanguage = function ($event, languageId) {
        $event.preventDefault();
        this.sessionDataProvider.setCurrentLanguageId(languageId);
    };
    /**
     * Checks whether current user is able to add category or even see create new button
     * @param categories: systemNames of categories to add
     */
    HeaderBarComponent.prototype.hasAddPermissionOnCategories = function (categories) {
        return this.hasPermissionOnCategories(categories, idm_authorization_client_js_1.PermissionType.ADD);
    };
    HeaderBarComponent.prototype.hasAddPermissionOnCategory = function (category) {
        return this.hasPermissionOnCategories([category], idm_authorization_client_js_1.PermissionType.ADD);
    };
    /**
     * Checks whether current user is able to add category or even see create new button
     * @param categories: systemNames of categories to add
     * @param categoryPermissionType category permission type: VIEW, ADD, EDIT or DELETE
     */
    HeaderBarComponent.prototype.hasPermissionOnCategories = function (categories, categoryPermissionType) {
        var _this = this;
        return categories.some(function (category) { return _this._categoryPermissions.get(categoryPermissionType).has(category); });
    };
    /**
     * Load category ADD permission and fill {@link _categoryPermissions} map.
     * @param categories: categories system names
     */
    HeaderBarComponent.prototype.loadAddPermissionForCategories = function (categories) {
        var _this = this;
        this._openSubscriptions.push(this.authenticationService.getUserData().subscribe(function (userData) {
            var userID = userData.userId;
            _this.authorizationService
                .getCategoryPermissionsValues({
                userId: userID,
                categorySystemNames: categories,
                workflowStateId: null,
                permissionType: idm_authorization_client_js_1.PermissionType.ADD,
                conditionalPermissionValues: null
            })
                .toPromise()
                .then(function (permissions) {
                permissions.forEach(function (values, categoryName) {
                    var anyAddPermission = Array.from(values).some(function (value) { return value.access !== idm_authorization_client_js_1.Access.DENIED; });
                    if (anyAddPermission) {
                        _this._categoryPermissions.get(idm_authorization_client_js_1.PermissionType.ADD).add(categoryName);
                    }
                });
            });
        }));
    };
    HeaderBarComponent.prototype.hasPermissionOnManageOwnProfile = function () {
        var _this = this;
        return this.authenticationService.getUserData()
            .switchMap(function (userData) {
            var userID = userData.userId;
            return _this.authorizationService.getPermissionAccessValue(userID, HeaderBarComponent_1.manageOwnProfilePermissionKey);
        });
    };
    HeaderBarComponent.prototype.listenToCalendarState = function () {
        var _this = this;
        var calendarStateObservable = this.eventBase.listen(this.CALENDAR_STATE_CHANGE_EVENT);
        this._openSubscriptions.push(calendarStateObservable.subscribe(function (event) {
            _this._isCalendarOpened = event.data.isCalendarOpened;
        }));
    };
    HeaderBarComponent.prototype.listenToNavigationPinState = function () {
        var _this = this;
        var navigationPinStateObservable = this.eventBase.listen(this.NAVIGATION_BAR_PIN_STATE_CHANGE_EVENT);
        this._openSubscriptions.push(navigationPinStateObservable.subscribe(function (event) {
            _this._pinState = event.data.pinState;
        }));
    };
    HeaderBarComponent.prototype.filterHeaderItems = function () {
        var _this = this;
        this._openSubscriptions.push(Observable_1.Observable.zip(Observable_1.Observable.fromPromise(this.headerBarService.showNotificationBell(this._configSrc)), this.isGuestUser()).subscribe(function (_a) {
            var show = _a[0], isGuestUser = _a[1];
            _this.showNotificationBell = show && !isGuestUser;
        }));
        this.headerBarService.showAbout(this._configSrc).then(function (show) {
            _this.showAbout = show;
        });
        this.headerBarService.showContact(this._configSrc).then(function (show) {
            _this.showContact = show;
        });
        this.headerBarService.showCalendar(this._configSrc).then(function (show) {
            _this.showCalendar = show;
        });
        this.headerBarService.showCalendarText(this._configSrc).then(function (show) {
            _this.showCalendarText = show;
        });
        this.headerBarService.showQRScanner(this._configSrc).then(function (show) {
            _this.showQRScanner = show;
        });
        this._openSubscriptions.push(Observable_1.Observable.zip(this.headerBarService.showUserProfile(this._configSrc), this.hasPermissionOnManageOwnProfile())
            .subscribe(function (_a) {
            var show = _a[0], permissionValueDto = _a[1];
            _this.showUserProfile = show && permissionValueDto.access === idm_authorization_client_js_1.Access.FULL;
        }));
    };
    var HeaderBarComponent_1;
    HeaderBarComponent.manageOwnProfilePermissionKey = '56a432d4-2d7d-4014-bec2-cb33509fba41';
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderBarComponent.prototype, "logoName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.Type)
    ], HeaderBarComponent.prototype, "aboutComponent", void 0);
    __decorate([
        core_1.HostListener('window:resize', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HeaderBarComponent.prototype, "onResize", null);
    HeaderBarComponent = HeaderBarComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-shell-header-bar',
            template: require('./header-bar.component.html'),
            styles: [require('./header-bar.component.css')]
        }),
        __param(0, core_1.Inject('configPath')),
        __param(1, core_1.Inject('imagesPath')),
        __metadata("design:paramtypes", [String, String, idm_authentication_client_js_1.AuthenticationService,
            idm_authorization_client_js_1.AuthorizationService,
            header_bar_service_1.HeaderBarService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_message_language_service_client_js_1.MessageService,
            toggle_full_screen_service_1.ToggleFullScreenService,
            router_1.Router,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            material_1.MatDialog,
            idm_session_data_provider_api_js_1.EventBase])
    ], HeaderBarComponent);
    return HeaderBarComponent;
}());
exports.HeaderBarComponent = HeaderBarComponent;
//# sourceMappingURL=header-bar.component.js.map